import { RootState } from 'editor/src/store/index';

const getFlatPreviewAvailable = (state: RootState) =>
  state.editorModules.preview.flatPreviewAvailable && !state.hostSettings.hidePreviewButton;

export default getFlatPreviewAvailable;
